import React from "react"

import { SearchItem } from "@/lib/azureSearchClient"
import { cn } from "@/lib/utils"
import { Link } from "@/components/ui/atoms"
import { Picture } from "@/components/ui/molecules"

type TCardSearchProps = {
  alt?: string
  className?: string
  data: SearchItem
}

const CardSearch = ({ alt, className, data }: TCardSearchProps) => {
  return (
    <article
      className={cn(
        "card-search flex w-full flex-col  items-stretch rounded-100 bg-neutral-100 lg:flex-row xl:h-[280px] xl:max-w-[49%]",
        className
      )}
    >
      {data.ImageUrl ? (
        <>
          <Picture
            src={data.ImageUrl + "?h=800&w=800&fm=webp&q=80"}
            alt={alt ? alt : ""}
            width={400}
            height={400}
            isRounded={false}
            variant={"default"}
            className="card-search--img hidden min-h-[200px] w-[200px] shrink-0 lg:block"
          />
          <Picture
            src={data.ImageUrl + "?h=3200&w=900&fm=webp&q=80"}
            alt={alt ? alt : ""}
            width={800}
            height={225}
            isRounded={false}
            variant={"default"}
            alignLeft={true}
            className="card-search--img h-[225px] max-h-[225px] min-h-[225px] shrink-0 overflow-hidden lg:hidden"
          />
        </>
      ) : null}
      <div className="flex size-full flex-col justify-between p-6 lg:p-7">
        <div>
          <header>
            <h2 className="heading-s pb-5 leading-[125%]">{data.Title}</h2>
          </header>
          <span className="paragraph-m text-neutral-400">
            {data.Description}
          </span>
        </div>

        {data.Path ? (
          <div className="flex justify-end">
            <Link
              chapters={[data.Title ?? "", "Lire"]}
              variant="ghost"
              iconRight="ArrowRight"
              className="mt-7 p-0"
              href={`/${data.Path}`}
            >
              Lire
            </Link>
          </div>
        ) : null}
      </div>
    </article>
  )
}

export { CardSearch, type TCardSearchProps }
